"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionName = void 0;
exports.CollectionName = {
    Users: 'Users',
    AuthorizedServices: 'AuthorizedServices',
    AuthorizedServicesAccounts: 'Accounts',
    Calendars: 'Calendars',
    OauthTokens: 'OauthTokens',
    OauthTokensTokens: 'Tokens',
    UserPublicProfiles: 'UserPublicProfiles',
    UserPublicBookingViewSettings: 'UserPublicBookingViewSettings',
    UserFreeFeatureToggles: 'UserFreeFeatureToggles',
    UserActivityStatuses: 'UserActivityStatuses',
    UserPlans: 'UserPlans',
    Companies: 'Companies',
    Bookings: 'Bookings',
    BookingForms: 'BookingForms',
    BookingPages: 'BookingPages',
    BookingPagePrivateParams: 'BookingPagePrivateParams',
    BookingPageMeataData: 'BookingPageMetaData',
    // Deprecated 削除したら消す
    CreatedBookingUrls: 'CreatedBookingUrls',
    // チーム
    Teams: 'Teams',
    Members: 'Members',
    StoredJobs: 'StoredJobs',
    TeamPlans: 'TeamPlans',
    UserABTestings: 'UserABTestings',
    CalendarNotificationChannels: 'CalendarNotificationChannels',
    UserAvailablePeriods: 'UserAvailablePeriods',
    CalendarAvailablePeriods: 'CalendarAvailablePeriods',
    UserOnboardingMissions: 'UserOnboardingMissions',
    Stripe: {
        Products: 'StripeProducts',
        Customers: 'StripeCustomers',
        Subscriptions: 'subscriptions',
        CheckoutSessions: 'checkout_sessions',
        Payments: 'payments'
    },
    // 将来的にSlackと重複するかも
    TeamsChatChannel: 'Channels',
    Reminds: 'Reminds',
    Forms: 'Forms',
    Inputs: 'Inputs',
    TeamShares: 'TeamShares'
};
//# sourceMappingURL=collectionName.js.map